// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3NZck","containerItemsCenter":"Skeleton_containerItemsCenter__ukGhk"};